export const config = {
  title: 'Move to Onboarding',
  bodyText: 'Are you sure you want to move this candidate to onboarding?',
  okText: 'Yes',
  cancelText: 'No',
  width: 420,
  successMessage: 'Moved to onboarding successfully',
  fields: [
    {
      name: 'sendOnboardingEmail',
      type: 'priority-checkbox',
      checkboxLabel: 'Send Onboarding Email',
    },
  ],
};
